import React, { useEffect, useState } from 'react';
import CoinIcon from 'utilities/components/coinIcon/coinIcon.index';
import { priceDigit } from 'scripts';
import { Badge, Button } from '30pay/components';
import { __ResultContentProps } from './resultContent.interface';
import { GetAllCoinType } from 'interfaces';
import { extractStateEnumText } from '../orderDetailModal.script';
import { __TypeOfOrderEnum } from '../../initial/initial.interface';
import moment from 'jalali-moment';
import { Typography } from 'antd';
import { Link } from 'react-router-dom';
import { PATH } from 'data/30pay.path';

const ConvertBoxResultContent: React.FC<__ResultContentProps> = (props: __ResultContentProps) => {
    const [coin, setCoin] = useState<GetAllCoinType | undefined>();

    useEffect(() => {
        if (props.data?.typeOfOrder === __TypeOfOrderEnum.buy) setCoin(props.data?.destCoin);
        else setCoin(props.data?.srcCoin);
    }, [props.data]);

    return (
        <div className="flex flex-col gap-6">
            {coin && (
                <div className="flex items-center gap-3">
                    <div className="flex items-center gap-3 text-darkPurple-100">
                        <CoinIcon symbol={coin.symbol} />
                        <label className="font-bold text-base">{coin.name}</label>
                        <span className="font-medium text-sm en">{coin.symbol}</span>
                    </div>
                    <span className="flex-1" />
                    <Badge
                        title={props.extraData?.state?.title ?? (props.isSuccess ? 'موفق' : 'ناموفق')}
                        type={props.isSuccess ? 'success' : 'warning'}
                    />
                </div>
            )}
            {props.data && (
                <div className="flex flex-col gap-4 w-full">
                    {props.data.typeOfOrder !== undefined && (
                        <div className="flex items-center w-full">
                            <label>نوع سفارش</label>
                            <span className="flex-1" />
                            <p>{extractStateEnumText(props.data.typeOfOrder)}</p>
                        </div>
                    )}
                    {props.data.srcValue !== undefined && (
                        <div className="flex items-center w-full">
                            <label>مقدار پرداختی</label>
                            <span className="flex-1" />
                            <p>
                                {priceDigit(props.extraData?.sourceAmount ?? props.data.srcValue)}{' '}
                                {props.data.srcCoin?.name}
                            </p>
                        </div>
                    )}
                    {props.data.srcValue !== undefined && (
                        <div className="flex items-center w-full">
                            <label>مقدار دریافتی</label>
                            <span className="flex-1" />
                            <p>
                                {priceDigit(props.extraData?.destinationAmount ?? props.data.destValue)}{' '}
                                {props.data.destCoin?.name}
                            </p>
                        </div>
                    )}
                    {props.data.srcPrice !== undefined && props.data.destPrice !== undefined && (
                        <div className="flex items-center w-full">
                            <label>قیمت واحد</label>
                            <span className="flex-1" />
                            <p>
                                {priceDigit(
                                    props.data.typeOfOrder === __TypeOfOrderEnum.swap
                                        ? props.data.srcPrice.cryptoIrtSellPrice /
                                              props.data.destPrice.cryptoIrtBuyPrice
                                        : props.data.typeOfOrder === __TypeOfOrderEnum.sell
                                          ? props.data.srcPrice.cryptoIrtBuyPrice
                                          : props.data.destPrice.cryptoIrtSellPrice,
                                )}{' '}
                                {props.data.typeOfOrder === __TypeOfOrderEnum.buy
                                    ? props.data.srcCoin?.name
                                    : props.data.destCoin?.name}
                            </p>
                        </div>
                    )}
                    {props.data.fee !== undefined && (
                        <div className="flex items-center w-full">
                            <label>کارمزد</label>
                            <span className="flex-1" />
                            <p>{priceDigit(props.data.fee)} تومان</p>
                        </div>
                    )}
                    {props.trackingCode !== undefined && (
                        <div className="flex items-center w-full">
                            <label>شناسه سفارش:</label>
                            <span className="flex-1" />
                            <Typography.Text copyable className="en">
                                {props.trackingCode}
                            </Typography.Text>
                        </div>
                    )}
                    {props.trackingCode !== undefined && (
                        <div className="flex items-center w-full">
                            <label>تاریخ و ساعت :</label>
                            <span className="flex-1" />
                            <p>{moment.utc(props.date).locale('fa').local().format('jD jMMMM jYYYY - HH:mm')}</p>
                        </div>
                    )}
                    {props.data?.destCoin?.symbol === 'UUSD' ? (
                        <div className="flex items-center w-full">
                            <label>کد ووچر</label>
                            <span className="flex-1" />
                            <Link to={PATH.reports} onClick={props.onClose} className="text-primary-100 hover:underline">
                                مشاهده در سوابق
                            </Link>
                        </div>
                    ) : (
                        <></>
                    )}
                    {props.data?.destCoin?.symbol !== 'UUSD' && props.data.typeOfOrder === __TypeOfOrderEnum.buy ? (
                        <div className="flex items-center w-full">
                            <label>هش برداشت</label>
                            <span className="flex-1" />
                            <Link to={PATH.reports} onClick={props.onClose} className="text-primary-100 hover:underline">
                                مشاهده در سوابق
                            </Link>
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            )}

            <div className="flex items-center w-full gap-4">
                <Button onClick={props.onClose} className="w-full" type="primary">
                    بستن
                </Button>
            </div>
        </div>
    );
};

export default ConvertBoxResultContent;
